import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Download } from 'lucide-react';
import { api } from '../../api/client';
import styles from './SubscribersPage.module.css';

const getSubscribers = () => api.get('/admin/subscribers').then(r => r.data.data);

export default function SubscribersPage() {
  const { t } = useTranslation();
  const { data, isLoading } = useQuery({ queryKey: ['admin-subscribers'], queryFn: getSubscribers });

  const handleExportCSV = () => {
    const subs = data?.subscribers || [];
    const csv = ['Email,Name,Phone,Subscribed At,Active',
      ...subs.map((s: Record<string, unknown>) => `${s.email},${s.name || ''},${s.phone || ''},${s.subscribedAt},${s.isActive}`)
    ].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `subscribers-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
  };

  return (
    <div>
      <div className={styles.header}>
        <h1 className={styles.pageTitle}>{t('admin.subscribers')}</h1>
        <button className={styles.exportBtn} onClick={handleExportCSV}>
          <Download size={16} /> Export CSV
        </button>
      </div>
      <p className={styles.count}>{data?.subscribers?.length || 0} subscribers</p>
      {isLoading ? (
        <p className={styles.loading}>{t('common.loading')}</p>
      ) : (
        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead><tr><th>Email</th><th>Name</th><th>Phone</th><th>Subscribed</th><th>Active</th></tr></thead>
            <tbody>
              {(data?.subscribers || []).map((s: Record<string, unknown>) => (
                <tr key={s.email as string}>
                  <td>{s.email as string}</td>
                  <td>{s.name as string || '—'}</td>
                  <td>{s.phone as string || '—'}</td>
                  <td className={styles.date}>{new Date(s.subscribedAt as string).toLocaleDateString('en-IN')}</td>
                  <td><span className={s.isActive ? styles.activeBadge : styles.inactiveBadge}>{s.isActive ? 'Yes' : 'No'}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
